var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.minDaysToShow === null || _vm.minDaysToShow >= _vm.daysTillExpired)?_c('span',{staticClass:"badge badge-success",class:{
    'badge-warning': _vm.daysTillExpired <= 42,
    'badge-danger': _vm.daysTillExpired <= 28,
    blink: _vm.daysTillExpired <= 28
  }},[(_vm.show === 'days')?_c('span',[_vm._v(_vm._s(_vm.daysTillExpired)+" days")]):_vm._e(),(_vm.show === 'date')?_c('span',[_vm._v(_vm._s(_vm._f("date")(_vm.expiryDate)))]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }